export default {
	items: [
		{
			name: 'Lista de Equipos',
			url: '/equipment-list',
			icon: 'fa fa-list-alt',
		},
		{
			name: 'Cerrar Sesión',
			url: '/logout',
			icon: 'icon-logout'
		},
	]
}
